import * as React from 'react';

import * as PopoverPrimitive from '@radix-ui/react-popover';

import { cn } from '@wwe-portal/ui/lib/lib';

const TooltipPortal = PopoverPrimitive.Portal;
const Tooltip: React.FC<
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Root>
> = ({ modal = true, ...props }) => {
  return <PopoverPrimitive.Root modal={modal} {...props} />;
};

const TooltipTrigger = PopoverPrimitive.Trigger;
const TooltipArrow = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Arrow>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Arrow>
>(({ className, ...props }, ref) => (
  <PopoverPrimitive.Arrow
    className={cn(className, 'fill-toolTipBgColor')}
    {...props}
    ref={ref}
  />
));
TooltipArrow.displayName = PopoverPrimitive.Arrow.displayName;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, sideOffset = 4, side = 'top', ...props }, ref) => (
  <PopoverPrimitive.Content
    className={cn(
      'bg-toolTipBgColor text-text300 shadow-tooltip animate-in fade-in-0 zoom-in-95 z-tooltip overflow-hidden rounded-[10px] p-5 text-xs focus-visible:outline-none',
      className
    )}
    sideOffset={sideOffset}
    side={side}
    {...props}
    ref={ref}
  />
));
TooltipContent.displayName = PopoverPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipArrow, TooltipPortal };
